/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CircleExclamationSolidV6 = (props) => (
  <Icon {...props} name="Circle Exclamation Solid V6">
    <path d="M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8c4.419 0 8-3.581 8-8s-3.581-8-8-8zm-.75 4.75c0-.412.338-.75.75-.75s.75.336.75.75v4a.75.75 0 0 1-1.5 0v-4zM8 12.5a.983.983 0 1 1 0-1.966.983.983 0 0 1 0 1.966z" />
  </Icon>
);

export default CircleExclamationSolidV6;
